import { useEffect, useRef } from 'react';

import styles from './bottom-sheet.less';

export const BottomSheetIFrameAdapter: React.FC<React.PropsWithChildren> = ({ children }) => {
    const touchEventsInterceptorRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const touchEventsInterceptor = touchEventsInterceptorRef.current;

        const handleTouchStart = (event: TouchEvent) => {
            const target = event.target as HTMLElement;
            target.style.pointerEvents = 'none';
            setTimeout(() => {
                target.style.pointerEvents = 'auto';
            }, 300);
        };

        touchEventsInterceptor?.addEventListener('touchstart', handleTouchStart);
        return () => touchEventsInterceptor?.removeEventListener('touchstart', handleTouchStart);
    }, []);

    return (
        <div className={styles.iframeWrapper}>
            {children}
            <div className={styles.iframeEventsInterceptor} ref={touchEventsInterceptorRef} />
        </div>
    );
};
